import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Dashboard from "./pages/Dashboard";
import HistoryDashboard from "./pages/HistoryDashboard";
import History from "./pages/History";
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/history" element={<HistoryDashboard />} />
        <Route path="/session/:sessionId" element={<History />} />
      </Routes>
    </div>
  );
}

export default App;
